export interface GrupoDescontoListResponse {
  id: string;
  nome: string;
  destino?: string;
}

export enum FormaAplicacaoValorEnum {
  ValorFixo = '1B04913A-6C46-4EBE-BFB3-F311EE9EA929',
  Porcentagem = '1B04913A-6C46-4EBE-BFB3-F311EE9EA928',
}
export interface GrupoDescontoForm {
  id?: string;
  nome: string;
  personalizado: boolean | '1' | '0';
  antesVencimento: boolean | '1' | '0';
  todasCategorias: boolean | '1' | '0';
  diasAntesVencimento: number;
  valor?: number;
  formaAplicacaoValorId: string;
  tipoDestinoId: string;
  destinoId?: string;
  categoriasIds: string[];
}